import { css } from "@emotion/core";
import { fontSizes, fonts, color } from "../../theme/Theme";

export const BillContainerStyles = css({
  ".ant-tabs-tab": {
    color: color.secondary,
    padding: "0.2rem",
    fontFamily: fonts.regular,
    fontSize: fontSizes.cardLabel
  },
  ".ant-tabs-tab-active": {
    color: color.secondary,
    fontFamily: fonts.bold,
    fontSize: fontSizes.cardLabel
  },
  ".ant-tabs-bar": {
    borderBottom: "0",
    marginBottom: "2rem"
  },
  ".ant-tabs-ink-bar": {
    height: "0.25rem"
  }
});
